import GradeLessonPage from '../components/GradeLessonPage';
import { grade7Topics } from './data';

export default function Grade7Page() {
  return (
    <GradeLessonPage
      grade="7"
      gradeLabel="Grade 7"
      gradeColor="amber"
      topics={grade7Topics}
      prevGrade={{ label: 'Grade 6', path: '/grade/6' }}
      nextGrade={{ label: 'Grade 8', path: '/grade/8' }}
    />
  );
}
